"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@developers/utils");
var InputTypes;
(function (InputTypes) {
    InputTypes["select"] = "select";
    InputTypes["text"] = "text";
})(InputTypes || (InputTypes = {}));
// interface PropsWithDefault = Props & React.SelectHTMLAttributes<HTMLSelectElement> & React.InputHTMLAttributes<HTMLInputElement>;
/**
 * Select box that changes into a text input if max number is selected
 *
 * @see [Documetation on NumberSelect](https://gitlab.fitness-plus.net/developers/ui#numberselect)
 */
function NumberSelect(props) {
    var low = props.low, high = props.high, value = props.value, disabled = props.disabled, onChange = props.onChange, selectStyle = props.selectStyle, selectClassName = props.selectClassName, inputClassName = props.inputClassName, inputStyle = props.inputStyle, inputProps = __rest(props, ["low", "high", "value", "disabled", "onChange", "selectStyle", "selectClassName", "inputClassName", "inputStyle"]);
    var textInput = react_1.default.useRef(null);
    var min = parseInt(low) || 1;
    var max = parseInt(high) || 9;
    var numbers = (0, utils_1.range)(min, max);
    var largestNumber = max + 1;
    var _a = react_1.default.useState(value > max), isOverMax = _a[0], setIsOverMax = _a[1];
    react_1.default.useEffect(function () {
        if (isOverMax) {
            textInput.current.focus();
        }
    }, [isOverMax]);
    var handleChange = function (type) { return function (e) {
        var newValue = e.target.value;
        if (newValue !== "") {
            if (!(0, utils_1.isNumeric)(newValue)) {
                newValue = replaceNonDigitWithEmptyString(newValue);
            }
            if (newValue > max) {
                setIsOverMax(true);
                props.onChange(parseInt(newValue), type);
            }
            else {
                props.onChange(parseInt(newValue), type);
            }
        }
        else {
            props.onChange('', type);
        }
    }; };
    if (isOverMax) {
        return (react_1.default.createElement("input", __assign({ type: "number", role: "input", value: value, onChange: handleChange('text'), className: inputClassName, style: inputStyle, min: min, ref: textInput, disabled: disabled }, inputProps)));
    }
    return (react_1.default.createElement("select", __assign({ role: "listbox", value: value, onChange: handleChange('select'), className: selectClassName, style: selectStyle, disabled: disabled }, inputProps),
        numbers.map(function (number) { return (react_1.default.createElement("option", { role: "option", key: number, value: number }, number)); }),
        react_1.default.createElement("option", { role: "select_option_plus", value: largestNumber + " +" },
            largestNumber,
            " +")));
}
exports.default = NumberSelect;
function replaceNonDigitWithEmptyString(value) {
    return value.replace(/[^\d,]+/g, "");
}
